import { Card, CardHeader, Divider, Stack, Typography } from "@mui/material";
import { useParams } from "react-router";
import { CommentsFeed, ContainerGrid, RolesList, RolesConfigurationWarningIcon } from "../../../components";
import { CommentSubject } from "../../../constants";
import { useRolesValidation } from "src/http";
import { UserAbout, UserStatisticsSummary } from "./components";

interface IParams {
  userId: string;
}

const UserOverviewPage = () => {
  const { userId } = useParams<keyof IParams>() as IParams;
  const { isEngagementValid, hasPrimaryRole } = useRolesValidation(userId);

  return (
    <ContainerGrid container spacing={{ xs: 0.5, md: 1 }}>
      <ContainerGrid size={12}>
        <UserStatisticsSummary />
      </ContainerGrid>
      <ContainerGrid size={{ xs: 12, md: 4 }}>
        <Card>
          <CardHeader title={<Typography variant="h6">Feed</Typography>} />
          <Divider />
          <CommentsFeed subjectType={CommentSubject.User} subjectGuid={userId} />
        </Card>
      </ContainerGrid>
      <ContainerGrid size={{ xs: 12, md: 4 }}>
        <Stack spacing={1}>
          <UserAbout />
        </Stack>
      </ContainerGrid>
      <ContainerGrid size={{ xs: 12, md: 4 }}>
        <Card>
          <CardHeader
            title={
              <Stack direction="row" spacing={0.25} sx={{
                alignItems: "center"
              }}>
                <Typography variant="h6">Roles</Typography>
                {(!isEngagementValid || !hasPrimaryRole) && (
                  <RolesConfigurationWarningIcon
                    userId={userId}
                    isEngagementValid={isEngagementValid}
                    hasPrimaryRole={hasPrimaryRole}
                  />
                )}
              </Stack>
            }
          />
          <Divider />
          <RolesList userId={userId} />
        </Card>
      </ContainerGrid>
    </ContainerGrid>
  );
};

export { UserOverviewPage };
